module.exports = __webpack_public_path__ + "static/media/passionn195169.5db17e16.svg";